import React, { useState } from "react";
import { Box, Typography, Button, Paper, alpha, Stack } from "@mui/material";
import RepaymentResultTable from "./RepaymentResultTable";
import CapitalAllowanceForm from "./CapitalAllowanceForm";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const RepaymentSchedule = ({
  caTypeOptions,
  caSettings,
  schedule,
  validation,
  step1Inputs,
  step2Results,
  onBackToForm,
  onStep2Submit,
}) => {
  const [showStep2, setShowStep2] = useState(false);

  const handleImportClick = () => {
    setShowStep2(true);
  };

  const handleStep2Submit = (inputs) => {
    onStep2Submit(inputs);
  };

  const handleBackToForm = () => {
    setShowStep2(false);
    onBackToForm();
  };

  return (
    <Box>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 2,
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.01),
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Box>
            <Typography variant='h6' fontWeight={600} color='primary.main'>
              HP Repayment Schedule
            </Typography>
            <Typography variant='body2' color='text.secondary' sx={{ mt: 0.5 }}>
              Review the generated repayment schedule
            </Typography>
          </Box>
          <Button
            onClick={handleBackToForm}
            variant='outlined'
            color='secondary'
            size='small'
            startIcon={<ArrowBackIcon />}
          >
            Back
          </Button>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 3,
            alignItems: "flex-start",
          }}
        >
          {/* Step 1 Result Table - Left Side */}
          <Box
            sx={{
              flex: showStep2 ? "1 1 50%" : "1 1 100%",
              minWidth: 0,
              transition: "flex 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          >
            <RepaymentResultTable
              schedule={schedule}
              validation={validation}
              fyEndMonth={step2Results?.inputs?.fyEndMonth}
              inAdvance={step1Inputs.inAdvance}
              onImportClick={handleImportClick}
              showImportButton={!showStep2}
            />
          </Box>

          {/* Step 2 - Right Side (Animated) */}
          {showStep2 && (
            <Box
              sx={{
                flex: showStep2 ? "1 1 50%" : "0 0 0%",
                minWidth: showStep2 ? 0 : 0,
                maxWidth: showStep2 ? "50%" : 0,
                overflow: "hidden",
                opacity: showStep2 ? 1 : 0,
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 2,
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.01),
                  border: (theme) =>
                    `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                  height: "100%",
                }}
              >
                <Stack spacing={4}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <Typography
                        variant='h6'
                        fontWeight={600}
                        color='primary.main'
                        gutterBottom
                      >
                        Capital Allowance Setup
                      </Typography>
                      <Typography
                        variant='body2'
                        color='text.secondary'
                        sx={{ mt: 0.5 }}
                      >
                        Configure capital allowance details for this asset
                      </Typography>
                    </Box>
                    <Button
                      onClick={() => setShowStep2(false)}
                      variant='outlined'
                      color='secondary'
                      size='small'
                    >
                      Close
                    </Button>
                  </Box>
                  <CapitalAllowanceForm
                    onSubmit={handleStep2Submit}
                    caTypeOptions={caTypeOptions}
                    caSettings={caSettings}
                    assetCost={step1Inputs.assetCost}
                    schedule={schedule}
                  />
                </Stack>
              </Paper>
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default RepaymentSchedule;
